import React from 'react';

/**
 * Дрібний підпис над заголовком: риска й кілька слів великими літерами.
 *
 * Той самий, що на сторінці контактів («Напряму», «Без сюрпризів»). Він
 * каже, про що блок, ще до заголовка, і дає секціям один спільний почерк
 * замість риски під кожним h2.
 *
 * teal-700 на білому й на slate-50 — понад 5:1, тож дрібний кегль тут
 * лишається читабельним і проходить AA.
 *
 * `tone="amber"` — для блоків-попереджень на бурштиновій підкладці
 * («Типові помилки»): бірюзовий підпис над бурштиновим блоком читався б як
 * чужий. Текст amber-800, а не 600–700: на amber-50 світліші відтінки
 * не дотягують до 4,5:1 на такому дрібному кеглі.
 */
const TONES = {
  teal: { line: 'from-teal-500 to-sky-400', text: 'text-teal-700' },
  amber: { line: 'from-amber-400 to-amber-300', text: 'text-amber-800' }
};

const Eyebrow = ({ children, as: Tag = 'p', id, tone = 'teal', className = 'mb-4' }) => {
  const palette = TONES[tone] || TONES.teal;
  return (
    <Tag id={id} className={`flex items-center gap-3 ${className}`}>
      <span className={`w-8 h-px bg-gradient-to-r ${palette.line} flex-shrink-0`} aria-hidden="true"></span>
      <span className={`${palette.text} uppercase tracking-[0.2em] text-[0.7rem] font-semibold leading-snug`}>{children}</span>
    </Tag>
  );
};

export default Eyebrow;
